module.exports = new __parcel__URL__("wsn-closed.dfca4c4b.png").toString();